import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeviceDto, DeviceStatus, DeviceType } from '../../../../../api/gen';

@Component({
  selector: 'app-zone-item-device',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './zone-item-device.component.html',
  styleUrl: './zone-item-device.component.scss'
})
export class ZoneItemDeviceComponent {
  @Input() device!: DeviceDto;

  getStatusClass(): string {
    const statusMap: Record<string, string> = {
      'Active': 'status-active',
      'Inactive': 'status-inactive',
      'Error': 'status-error',
      'Unknown': 'status-unknown'
    };
    return statusMap[this.device.deviceStatus ?? ''] || 'status-unknown';
  }

  getStatusIcon(): string {
    const iconMap: Record<string, string> = {
      'Active': 'check_circle',
      'Inactive': 'radio_button_unchecked',
      'Error': 'error_circle',
      'Unknown': 'help'
    };
    return iconMap[this.device.deviceStatus ?? ''] || 'help';
  }

  getTypeIcon(): string {
    const iconMap: Record<string, string> = {
      'Camera': 'videocam',
      'ParkingSensor': 'sensors',
      'LPR': 'document_scanner',
      'Controller': 'memory',
      'Unknown': 'devices'
    };
    return iconMap[this.device.deviceType ?? ''] || 'devices';
  }

  getTypeLabel(): string {
    const labelMap: Record<string, string> = {
      'Camera': '📷 Camera',
      'ParkingSensor': '🔍 Parking Sensor',
      'LPR': '📋 LPR',
      'Controller': '🖥️ Controller',
      'Unknown': 'Unknown Device'
    };
    return labelMap[this.device.deviceType ?? ''] || this.device.deviceType || 'Unknown';
  }
}

